// extracted by mini-css-extract-plugin
export default {"questionCard":"OtherLiabilitiesSection_questionCard__8XdfQ","buttons":"OtherLiabilitiesSection_buttons__TV+nA","amountFields":"OtherLiabilitiesSection_amountFields__+4oNA"};